<template>
    <div>
        <app-sub-title :text="`Diligenciar formato: ${formatName}`" />
        <b-card>
            <b-card-body>
                <b-row v-for="field in fields" :key="field.key">
                    <b-col>
                        <component
                            :is="getField(field.type)"
                            :label="field.label"
                            :id="new String('' + field.key + '')"
                            :type="field.type"
                            :required="!!field.required"
                            :options="getOptions(field.meta)"
                            @change="onChange(field.key, $event)"
                        ></component>
                    </b-col>
                </b-row>
                <b-col cols="12" class="mt-4">
                    <label for=""
                        >Firma<span class="field-required-mark">*</span></label
                    >
                    <app-vue-signature
                        id="signature"
                        width="100%"
                        height="100px"
                        ref="signaturePad"
                    />
                    <div class="pull-right">
                        <br />
                        <b-btn variant="secondary" size="sm" @click="undo"
                            >Borrar</b-btn
                        >
                    </div>
                </b-col>
            </b-card-body>
            <button class="btn btn-primary" @click="startSave">
                <i class="fa fa-plus"></i> Registrar
            </button>
        </b-card>
        <app-pop-up title="Confirmación" id="save-format">
            <div slot="body">
                <h3>¿Esta seguro que desea realizar el registro?</h3>
            </div>
            <div class="buttons" slot="buttons">
                <button class="btn btn-confirm" @click="save()">
                    <i class="fa fa-trash" aria-hidden="true"></i> Confirmar
                </button>
            </div>
        </app-pop-up>
    </div>
</template>
<script>
import Title from '../../UI/Layout/Title.vue'
import PageContent from '../../UI/Layout/PageContent.vue'
import InputField from './InputField.vue'
import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import VueSignature from 'vue-signature-pad'
import FormInput from '../../UI/Controls/Forms/FormInput.vue'
import FormSelectInput from '../../UI/Controls/Forms/FormSelectInput.vue'
import FormDate from '../../UI/Controls/Forms/FormDate.vue'
import FormTimeInput from '../../UI/Controls/Forms/FormTimeInput.vue'
import FormTextareaInput from '../../UI/Controls/Forms/FormTextareaInput.vue'
import FormDatetime from '../../UI/Controls/Forms/FormDatetime.vue'
import FormTime from '../../UI/Controls/Forms/FormTime.vue'
export default {
    components: {
        appPageContent: PageContent,
        appInputField: InputField,
        appTitle: Title,
        appVueSignature: VueSignature,
    },
    props: {
        formatId: {
            type: Number,
            default: 0,
        },
        formatName: {
            type: String,
            default: '',
        },
    },
    data: () => ({
        version: '',
        active: 0,
        fields: [],
        firm: '',
        formFields: [],
    }),
    validations: {},
    computed: {
        isValidSaving() {
            return this.fields.length > 0
        },
    },
    created() {
        this.getFields()
    },
    methods: {
        getField(type) {
            return {
                text: FormInput,
                list: FormSelectInput,
                date: FormDate,
                number: FormTimeInput,
                text_area: FormTextareaInput,
                datetime: FormDatetime,
                time: FormTime,
            }[type]
        },
        getOptions(meta) {
            if (!meta) return []
            let options = []
            options = JSON.parse(meta)
            return options.options
        },
        async getFields() {
            const { data } = await repo.get(
                `formats/format/${this.formatId}/load-fields-data`
            )
            if (data) {
                this.fields = data
                this.fields.forEach(item => {
                    this.formFields.push({
                        id: item.key,
                        value: '',
                    })
                })
                console.log(this.formFields)
            }
        },
        onChange(val, event) {
            let field = this.formFields.find(item => {
                return item.id == val
            })
            if (field) {
                field.value = event.replace(new RegExp('\r?\n', 'g'), '. ')
                field.id = val
            }
            console.log(this.formFields)
        },
        undo() {
            this.$refs.signaturePad.undoSignature()
        },

        getFieldStructure() {
            return {
                id: new Date().getTime(),
                type: '',
                meta: '',
                order: '0',
                required: true,
            }
        },

        async startSave() {
            console.log('inicio')

            for (let i = 0; i < this.fields.length; i++) {
                if (!this.fields[i].required) continue

                if (
                    !this.formFields.find(
                        item => item.id === this.fields[i].key
                    ).value
                ) {
                    console.log('Field', this.fields[i])
                    toastr.error(
                        `Debe diligenciar el campo ${this.fields[i].label}`
                    )
                    return
                }
            }

            const { data } = this.$refs.signaturePad.saveSignature()
            if (data) {
                this.firm = data
            } else {
                this.firm = ''
                toastr.error('El cliente debe firmar en el panel')
                return false
            }

            let params = {
                personId: this.user.id,
                fields: this.formFields,
                firm: this.firm,
            }

            if (!this.isValidSaving) {
                toastr.warning(
                    'Debe completar los campos requeridos y la firma'
                )
                return
            }
            console.log(this.firm)
            console.log(params)
            this.$bus.$emit('save-format.open')
        },
        async save() {
            let params = {
                personId: this.user.id,
                formatId: this.formatId,
                fields: this.formFields,
                firm: this.firm,
            }
            console.log(params)
            const { data } = await repo.post('format-headers', params)
            console.log('envio form')
            console.log(data.status)
            if (data.status) {
                this.$bus.$emit('save-format.close')
                this.$router.push({ name: 'formatsPage' })
            } else {
                toastr.error(data.msg)
                this.$emit('error', data)
            }
        },
    },
}
</script>
<style>
#signature {
    border: double 3px transparent;
    border-radius: 5px;
    background-image: linear-gradient(white, white),
        radial-gradient(circle at top left, #4bc5e8, #9f6274);
    background-origin: border-box;
    background-clip: content-box, border-box;
}
</style>
